import { isPlainObject } from 'lodash-es';

export default function cleanObjectProperties(sourceObject = {}, keepEmptyStrings = false): object {
  // mpetrov: prevent the side effect
  const obj = { ...sourceObject };

  Object.keys(obj).forEach((key) => {
    if (obj[key] && isPlainObject(obj[key])) {
      obj[key] = cleanObjectProperties(obj[key], keepEmptyStrings); // recursive for objects
    } else if (keepEmptyStrings && obj[key] === '') {
      // keep explicit empty-string filter values (e.g. API range filters where `field=` is meaningful)
    } else if ((typeof obj[key] !== 'boolean' && !obj[key]) || (Array.isArray(obj[key]) && obj[key].length === 0)) {
      delete obj[key]; // remove empty properties
    }

    if (isPlainObject(obj[key]) && Object.keys(obj[key]).length === 0) {
      delete obj[key]; // remove empty objects
    }
  });

  return obj;
}
